import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const links = [
  { href: "/#services", label: "Services" },
  { href: "/#global", label: "Global" },
  { href: "/#reviews", label: "Reviews" },
  { href: "/#book", label: "Enquire" },
  { href: "/#consultation", label: "Consult" },
  { href: "/about", label: "About", route: true },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-navy/70 border-b border-ivory/10" : ""
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="group" data-testid="nav-brand">
          <div className="font-mono-ui text-xs tracking-[0.35em] text-gold uppercase">Est. London, UK</div>
          <div className="font-display text-2xl md:text-3xl leading-none text-ivory">
            The Visa <span className="italic text-gold">Atelier</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {links.map((l) =>
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="font-mono-ui text-sm tracking-[0.22em] uppercase text-ivory/85 hover:text-gold transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="font-mono-ui text-sm tracking-[0.22em] uppercase text-ivory/85 hover:text-gold transition-colors"
              >
                {l.label}
              </a>
            )
          )}
        </nav>
        <a
          href="/#book"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center gap-3 px-6 py-3 border border-gold text-gold font-mono-ui text-sm tracking-[0.22em] uppercase hover:bg-gold hover:text-navy transition-colors"
        >
          Begin — <span aria-hidden>↗</span>
        </a>
      </div>
    </motion.header>
  );
}
